import React from 'react';
import { Link } from 'react-router-dom';
import { connect, useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';

import { toggleDrawer } from '~features/drawer/ducks';
import logo from '~images/logo-paketti-text.svg';
import userImg from '~images/user-icon.svg';
import notificationsImg from '~images/PAKE_ota_yhteytta_valkoinen.svg';
import userImgMobile from '~images/user-icon-blue.svg';
import notificationsImgMobile from '~images/PAKE_ota_yhteytta.svg';
// import userWhiteImg from '~images/profiili-valkoinen.svg';
import { getUser } from '~features/user/ducks';
import { topNavHeight } from '~utils/common.utils';
import NavButton from './NavButton';

// import {
//   setShow as setModalShow,
//   setOrderId,
//   setNpsUrl,
// } from '~features/modals/ducks';

const getName = (user, isDesktop) => {
  if (!user) return 'Käyttäjä';

  return isDesktop ? user.name : user.name.split(' ')[0];
};

const TopNav = ({ user }) => {
  const dispatch = useDispatch();
  const isDesktop = useSelector(state => state.reducer.isDesktop);
  const notifications = useSelector(state => state.user.notifications);
  const showCcNotification = useSelector(
    state => state.user.data.showCcNotification
  );
  // const showProjects = useSelector(state => state.reducer.labels.showprojects);

  const unreadCount = notifications?.filter(n => !n.seen).length;
  // Show badge if there are unseen notifications
  const showBadge = !!unreadCount;
  const showProfileBadge = showCcNotification;

  return (
    <TopNavWrapper>
      <div className="container">
        <InnerWrapper>
          <Link to="/">
            <Logo src={logo} alt="logo" />
          </Link>
          <UserUnit>
            Käyttäjän yksikkö Paketissa: {user?.ordererOrganization.name}
          </UserUnit>
          <NavIcons>
            <NavButton
              onClick={() => dispatch(toggleDrawer('notifications'))}
              icon={isDesktop ? notificationsImg : notificationsImgMobile}
              showBadge={showBadge}
              mobile={!isDesktop}
            >
              Ilmoitukset{showBadge && ` (${unreadCount})`}
            </NavButton>
            <NavButton
              onClick={() => dispatch(toggleDrawer('profile'))}
              icon={isDesktop ? userImg : userImgMobile}
              showBadge={showProfileBadge}
              mobile={!isDesktop}
            >
              {getName(user, isDesktop)}
            </NavButton>
            {/* <NavButton
              icon={userImg}
              onClick={() => {
                dispatch(setOrderId(52091));
                dispatch(setNpsUrl('0.0.0.0:5001'));
                dispatch(setModalShow('EXTERNAL_FEEDBACK'));
              }}
            >
              Avaa NPS
            </NavButton> */}
          </NavIcons>
        </InnerWrapper>
      </div>
    </TopNavWrapper>
  );
};

const TopNavWrapper = styled.div`
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  left: 0;
  right: 0;
  height: ${topNavHeight}px;
  // line-height: ${topNavHeight}px;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  z-index: 5;

  & + * {
    padding-top: 20px;
  }

  @media screen and (min-width: 768px) {
    & + * {
      padding-top: 35px;
    }
  }
`;

const Logo = styled.img`
  width: auto;
  margin: -6px 6px 0 0;
  height: 32px;

  @media (max-width: 768px) {
    width: auto;
    margin: 0 0 3px;
    height: 25px;
  }
`;

const UserUnit = styled.div`
  margin-left: 8px;
  color: var(--primaryColor);
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

const NavIcons = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default connect(state => ({
  user: getUser(state),
  approvableCount: state.transferReducers.approvableCount,
}))(TopNav);
